import { COLORS } from '@/styles/colors';
import { body, bodySmall } from '@/styles/typography';
import styled from 'styled-components';

export const ActionLinkWrapper = styled.a<{ size: 'medium' | 'large' }>`
  display: inline-block;
  color: ${COLORS.green[500]};
  ${bodySmall};
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  ${({ size }) =>
    size === 'large' &&
    `
    ${body};
  `};
`;
